import { mainPath } from "../../lib/mainPath";
import { requestsTemplates } from "../../lib/requestsTemplates";

export const getCurrentWeek = (params) =>
  requestsTemplates.get(mainPath, `/vacations/week/current`, params);
